// CREDIT: https://uxwing.com/plus-square-line/

function IconPlusSquare(options){
  !options.style && (options = { 
    ...options,
    // style: { width: '1.5em', height: '1.5em', marginBottom: '0.1em' }, 
  })
  return (
    <svg 
      {...options}
      version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="122.879px" height="122.88px" viewBox="0 0 122.879 122.88" enableBackground="new 0 0 122.879 122.88" xmlSpace="preserve">
      <g>
        <path stroke='currentcolor' fill='currentcolor' d="M8.773,0h105.332c2.417,0,4.611,0.986,6.199,2.574c1.589,1.588,2.574,3.783,2.574,6.199v105.333 c0,2.416-0.985,4.61-2.574,6.199c-1.588,1.588-3.782,2.574-6.199,2.574H8.773c-2.416,0-4.611-0.986-6.199-2.574 C0.986,118.717,0,116.522,0,114.106V8.773c0-2.417,0.986-4.611,2.574-6.199S6.357,0,8.773,0L8.773,0z M57.876,30.852 c0-1.968,1.596-3.564,3.563-3.564c1.969,0,3.563,1.596,3.563,3.564v27.024l27.024,0c1.969,0,3.563,1.596,3.563,3.563 s-1.595,3.563-3.563,3.563H65.003v27.024c0,1.969-1.596,3.563-3.563,3.563s-3.563-1.595-3.563-3.563V65.003H30.852 c-1.968,0-3.563-1.595-3.563-3.563c0-1.968,1.596-3.563,3.563-3.563h27.024V30.852L57.876,30.852z M114.105,7.129H8.773 c-0.449,0-0.859,0.186-1.159,0.485c-0.3,0.3-0.486,0.71-0.486,1.159v105.333c0,0.448,0.186,0.859,0.486,1.159 c0.3,0.299,0.71,0.485,1.159,0.485h105.332c0.449,0,0.86-0.187,1.159-0.485c0.3-0.3,0.486-0.711,0.486-1.159V8.773 c0-0.449-0.187-0.859-0.486-1.159C114.966,7.315,114.555,7.129,114.105,7.129L114.105,7.129z"/>
      </g>
    </svg>
  )
}

export default IconPlusSquare